<script setup>
import BaseModal from "@/components/global/modals/BaseModal.vue";

const emit = defineEmits(['close', 'confirm']);

defineProps({
  endDate: {
    required: true,
    type: String,
  },
});
</script>

<template>
  <Teleport to="body">
    <BaseModal
      id="cancelling-website-warning-modal"
      @close="emit('close')"
    >
      <template #heading>
        Do you want to stop the website being deleted?
      </template>
      <div class="text-center">
        <p>Currently your website is due to be deleted on <strong>{{ endDate }}</strong> if you want to stop this from happening please confirm below.</p>

        <p>By clicking on confirm the website we be made active again and your subscription will be updated.</p>
      </div>
      <template #footer>
        <div class="w-100 d-flex justify-content-center">
          <button
            class="border-0 border-radius-6 btn-block button font-weight-bold h-100 px-5 btn-success w-auto"
            @click="emit('confirm')"
          >
            Confirm
          </button>
        </div>
      </template>
    </BaseModal>
  </Teleport>
</template>

<style>
#cancelling-website-warning-modal .modal_window {
  max-width: 900px !important;
}
</style>
